module.exports = __webpack_public_path__ + "static/diagram_gpa_tree-770919895a1b8601631bd66126fb4cf5.png";